export const DAY_HEADINGS = ['ПН<br>10-22', 'ВТ<br>10-22', 'СР<br>10-22', 'ЧТ<br>10-22', 'ПТ<br>10-22', 'СБ<br>10-22', 'ВС<br>10-22']
export const NIGHT_HEADINGS = ['ПН 22 - ВТ 10', 'ВТ 22 - СР 10', 'СР 22 - ЧТ 10', 'ЧТ 22 - ПТ 10', 'ПТ 22 - СБ 10', 'СБ 22 - ВС 10', 'ВС 22 - ПН 10']
export const FULL_DAY_HEADINGS = ['ПН 10 - ВТ 10', 'ВТ 10 - СР 10', 'СР 10 - ЧТ 10', 'ЧТ 10 - ПТ 10', 'ПТ 10 - СБ 10', 'СБ 10 - ВС 10', 'ВС 10 - ПН 10']
export const DAYS_OF_WEEK = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']

export const pad = (s) => {
 if (`${s}`.length < 2) return `0${s}`
 return s
}